import VsChart from './VsChart.vue'
import VsSvgLine from './components/SvgLine'
import VsSvgBar from './components/SvgBar'
import VsSvgPie from './components/SvgPie'
VsChart.install = function (Vue) {
    Vue.component(VsChart.name, VsChart)
    Vue.component(VsSvgLine.name, VsSvgLine)
    Vue.component(VsSvgBar.name, VsSvgBar)
    Vue.component(VsSvgPie.name, VsSvgPie)
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(VsChart)
}

export {
    VsChart,
    VsSvgLine,
    VsSvgBar,
    VsSvgPie
}

export default VsChart
